import { render, staticRenderFns } from "./layout-default-content.vue?vue&type=template&id=240c56b6&"
import script from "./layout-default-content.vue?vue&type=script&lang=js&"
export * from "./layout-default-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports